import { render } from "./Exports.vue?vue&type=template&id=33f36e2a"
import script from "./Exports.vue?vue&type=script&lang=js"
export * from "./Exports.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__